import React from "react";
import styled from "styled-components";

import { ConnectButton, GetConnectButtonState } from "../connect-button";

interface AccountListProps<T> {
  className?: string;
  items: T[];
  getConnectButtonState: GetConnectButtonState<T>;
  renderItemLabel(item: T): React.ReactNode;
  onConnect(item: T): void;
}

export function AccountList<T>({
  className,
  items,
  getConnectButtonState,
  renderItemLabel,
  onConnect,
}: AccountListProps<T>) {
  return (
    <List className={className}>
      {items.map((item, index) => (
        <li key={index}>
          <ConnectButton
            state={getConnectButtonState(item)}
            onClick={() => onConnect(item)}
          />{" "}
          {renderItemLabel(item)}
        </li>
      ))}
    </List>
  );
}

const List = styled.ul`
  margin: 0;
  list-style: none;
  padding-left: 24px;

  & > li:not(:first-child) {
    margin-top: 4px;
  }
`;
